export default __webpack_public_path__ + "static/media/employee-spot-hover.92cee664.jpg";